import Immutable  from "immutable";
import axios from "axios";

const initialState = {
    authenticated: false,
    token: "",
    email: ""
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "LOAD_SESSION":
            if(typeof action.value.session === 'undefined' || typeof action.value.session.token === 'undefined') {
                return Immutable.fromJS(initialState).toJS();
            }
            if(action.value.session.token) {
                axios.defaults.headers.common["Authorization"] = "Bearer " + action.value.session.token;
            }
            return action.value.session;
        case "SIGN_IN_FULFILLED":
        case "SIGN_IN_BY_TOKEN_FULFILLED":
            axios.defaults.headers.common["Authorization"] = "Bearer " + action.payload.data.token;
            return Immutable
                .fromJS(state)
                .set("authenticated", true)
                .set("token", action.payload.data.token)
                .set("email", action.payload.data.email)
                .toJS();
        case "SIGN_IN_REJECTED":
        case "SIGN_IN_BY_TOKEN_REJECTED":
            delete axios.defaults.headers.common["Authorization"];
            return Immutable
                .fromJS(state)
                .set("authenticated", false)
                .set("token", "")
                .set("email", "")
                .toJS();
        case "SESSION_EXPIRED":
        case "SIGN_OUT":
            delete axios.defaults.headers.common["Authorization"];
            return Immutable
                .fromJS(state)
                .set("authenticated", false)
                .set("token", "")
                .set("email", "")
                .toJS();                
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js